/* PAINTRANGER - Die Laenderliste erst beim Oeffnen aufbauen.

   Der Shop liefert in 236 Laender. Das Theme baut die komplette Liste
   dreimal in jede Seite: Kopfzeile am Rechner, Menue-Schublade am Handy
   und Fussbereich. Zusammen sind das rund 5.000 Elemente, die der Browser
   bei jedem Seitenaufruf aufbauen, berechnen und im Speicher halten muss,
   obwohl fast niemand die Auswahl jemals oeffnet.

   Deshalb liegen die Listen jetzt in einem <template>. Das steht zwar im
   Quelltext der Seite, ist aber kein Teil der Seite: der Browser baut
   daraus nichts auf und rechnet nichts dafuer aus. Erst wenn jemand die
   Laenderauswahl anfasst, wird die Liste an genau dieselbe Stelle gesetzt,
   an der sie vorher stand.

   Sichtbar aendert sich nichts. Auch das Suchfeld, die Pfeiltasten und die
   Auswahl selbst arbeiten danach wie vorher, weil die Liste mit demselben
   Klick-Verhalten verknuepft wird, das das Theme-Bauteil sonst beim Laden
   vergibt.

   Rein additiv: die Datei tut nichts, solange es keine <template> mit der
   Klasse pf-country-list gibt.
*/
(function () {
  'use strict';

  if (window.pfCountryLazyReady) return;
  window.pfCountryLazyReady = true;

  function fill(form) {
    var tpl = form.querySelector('template.pf-country-list');
    if (!tpl || !tpl.parentNode) return;

    var host = tpl.parentNode;
    host.insertBefore(tpl.content.cloneNode(true), tpl);
    host.removeChild(tpl);

    // Dasselbe Klick-Verhalten, das <localization-form> sonst beim Laden
    // an jeden Eintrag haengt.
    if (typeof form.onItemClick === 'function') {
      var links = host.querySelectorAll('a');
      for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', form.onItemClick.bind(form));
      }
    }
  }

  function onInteraction(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('.localization-form__select');
    if (!button) return;

    var form = button.closest('localization-form');
    if (form) fill(form);
  }

  // Mitschneiden, bevor das Theme-Bauteil die Auswahl aufklappt.
  document.addEventListener('pointerdown', onInteraction, true);
  document.addEventListener('keydown', onInteraction, true);
  document.addEventListener('focusin', onInteraction, true);
})();